import { PointOfSale } from "@mui/icons-material";
import { GridSortCellParams } from "@mui/x-data-grid";
import { GridSortDirection } from "@mui/x-data-grid-pro";

export default class Utils {
  static maskNumberToSAPDecimal(numberStr: string): string {
    numberStr = numberStr.replace(".", "").replace(",", "").replace(/\D/g, "");

    const options = { minimumFractionDigits: 3 };
    const result = new Intl.NumberFormat("pt-BR", options).format(
      parseFloat(numberStr) / 1000
    );

    return result == "NaN" ? "" : result; // TODO Refactoring this line, NAN is returned when the code is a problem.
  }

  static maskNumberToSAPDecimalVisualization(
    number: string,
    trailing: string = ""
  ) {
    return Utils.maskNumberToSAPDecimal(number).replace(",000", "") + trailing;
  }

  static round3(value: number): string {
    return value ? Utils.stripZeros(value.toFixed(3)) : "0";
  }

  static stripZeros(str: string): string {
    return parseFloat(str.replace(",", ".")).toString().replace(".", ",");
  }

  static setDocumentTitle(title: string, extra: string = ""): void {
    document.title = `${title}${extra ? ` ${extra}` : ""} | Portal Copackers`;
  }

  static generateUnicHex = (value: number, padding = 0) => {
    padding = padding === 0 ? value.toString(16).length : padding;
    return value.toString(16).padEnd(padding, "0").toUpperCase();
  }
  static generateArrayHex = (max: number) => {
    const padding = max.toString(16).length;
    return Array.from({ length: max }).fill(0).map((_, i) => Number(i).toString(16).padEnd(padding, "0").toUpperCase())
  }

  static sorterColumn = () => {
    const DEFAULT_YEAR = 1970, DEFAULT_MONTH = 1, DEFAULT_DAY = 1;
    const MONTH_MINEMONIC = 'M', YEAR_MINEMONIC = 'Y', DAY_MINEMONIC = 'D';

    const sortingOrder = (): GridSortDirection[] => {
      return ['asc', 'desc', undefined ];
    }

    /**
     * @param type Date format ex: MM/YYYY, DD/MM/YYYY, YYYY-MM-DD -> DD For Day, MM for Month and YYYY for Year
     * @returns -1 | 0 | 1
     */
    const sortComparator = (type: string) => {
      return <T,>(v1: T, v2: T, p1: GridSortCellParams<T>, p2: GridSortCellParams<T>): number => {
        try {
          const infoA = [
            Number(String(v1).slice(String(type).indexOf(YEAR_MINEMONIC), String(type).lastIndexOf(YEAR_MINEMONIC) + 1)) || DEFAULT_YEAR,
            (Number(String(v1).slice(String(type).indexOf(MONTH_MINEMONIC), String(type).lastIndexOf(MONTH_MINEMONIC) + 1)) || DEFAULT_MONTH) - 1,
            Number(String(v1).slice(String(type).indexOf(DAY_MINEMONIC), String(type).lastIndexOf(DAY_MINEMONIC) + 1)) || DEFAULT_DAY
          ]

          const infoB = [
            Number(String(v2).slice(String(type).indexOf(YEAR_MINEMONIC), String(type).lastIndexOf(YEAR_MINEMONIC) + 1)) || DEFAULT_YEAR,
            (Number(String(v2).slice(String(type).indexOf(MONTH_MINEMONIC), String(type).lastIndexOf(MONTH_MINEMONIC) + 1)) || DEFAULT_MONTH) - 1,
            Number(String(v2).slice(String(type).indexOf(DAY_MINEMONIC), String(type).lastIndexOf(DAY_MINEMONIC) + 1)) || DEFAULT_DAY
          ]

          const A = new Date(...(infoA as [])), B = new Date(...(infoB as []));
          return (A.getTime() < B.getTime()) ? -1 : (A.getTime() === B.getTime() ? 0 : 1);
        } catch (err) {
          return 0;
        }
      }
    }

    return {
      sortingOrder,
      sortComparator,
    }

  }

  static firstLetterToUpperCase = (value:string)=>{
    return `${value.charAt(0).toUpperCase()}${value.substring(1)}`;
  }
}
